import React, { useState, useEffect } from 'react';
import { Alert, Button, Box, Title, Text, FileInput, Input, Grid, TextInput } from '@mantine/core';
import { toast } from 'react-toastify';
import MyDocument from '../../components/Document';
import VerificareDocument from '../../components/VerificareDocument';
import MesajInchidere from '../../components/MesajInchidere';
import { usePlatforma } from '../../platforma';

const INTREBARE_STUDENT = 'Ești sigur că toate datele sunt corecte, titlul este cel dorit și FINAL, iar documentul este semnat DOAR de tine?';

function GeneratePage({ student, solicitare, professor, requestOptions, refresh, cerere }) {
    const SERVER = process.env.REACT_APP_SERVER;
    const [file, setFile] = useState(null);
    const [confirmat, setConfirmat] = useState(false);
    const [seIncarca, setSeIncarca] = useState(false);
    const [titluCerere, setTitluCerere] = useState('');
    const [titluIncarcare, setTitluIncarcare] = useState('');
    const { inchisa } = usePlatforma();

    // o cerere noua se poate incarca doar daca nu exista niciuna
    // sau daca profesorul a solicitat modificari la cea mai recenta
    const modificariSolicitate = cerere?.mesaj_modificari;
    const poateIncarca = !cerere || !!modificariSolicitate;

    const verificaCerere = async () => {
        const res = await fetch(SERVER + 'cerere/titlu', { ...requestOptions('GET') });
        if (!res.ok) {
            toast.error('Eșuare încărcare!');
        }
        const data = await res.json();
        if (data && data.titlu && data.titlu.titlu) {
            setTitluIncarcare(data.titlu.titlu)
        } else {
            setTitluIncarcare(solicitare?.titlu || '');
        }
    }

    useEffect(() => {
       student && solicitare && professor && verificaCerere();
    }, [student, solicitare, professor]);

    const adaugaCerere = () => {
        fetch(SERVER + 'cerere/titlu', {
            method: 'POST',
            headers: {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                titlu: titluCerere
            }),
        })
            .then((res) => {
                if (!res.ok) {
                    toast.error('Eșuare salvare titlu!');
                }
                if (res.ok) {
                    toast.success(`Ai salvat titlul: ${titluCerere}`);
                }
                return res.json();
            })
            .then((data) => { verificaCerere() });
    }

    const onFileChange = (uploadedFile) => {
        setFile(null);
        if (!uploadedFile) return;
        if (uploadedFile.size / 1024 / 1024 > 15) {
            toast.error('Fișierul este prea mare! Dimensiunea maximă este 15 MB.');
            return;
        }
        const parts = uploadedFile.name.split('.');
        const extension = parts[parts.length - 1].toLowerCase();
        if (extension !== 'pdf') {
            toast.error('Puteți încărca doar fișiere PDF!');
            return;
        }
        setFile(uploadedFile);
    };

    const onUpload = () => {
        if (!file) {
            toast.error('Alege fișierul pe care vrei să îl încarci!');
            return;
        }
        if (titluIncarcare.length === 0) {
            return toast.error('Titlul nu poate fi gol!');
        }
        const fileReader = new FileReader();
        fileReader.onload = async (e) => {
            setSeIncarca(true);
            try {
                const res = await fetch(SERVER + 'cerere', {
                    method: 'POST',
                    headers: {
                        Authorization: localStorage.getItem('token'),
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        titlu: titluIncarcare,
                        fisier: e.target.result,
                        idProfesor: professor.id,
                    }),
                });
                const data = await res.json();
                if (!res.ok) {
                    toast.error(data.error || 'Eșuare încărcare!');
                    return;
                }
                toast.success('Cererea a fost încărcată cu succes!');
                setFile(null);
                refresh();
            } catch (err) {
                toast.error('Eșuare încărcare!');
            } finally {
                setSeIncarca(false);
            }
        };
        fileReader.readAsDataURL(file);
    };

    const stilLatime = () => ({
        width: '100%',
        maxWidth: '500px',
        '@media (max-width: 600px)': { width: '100%' }
    });

    // dupa inchiderea platformei nu se mai salveaza titluri, nu se mai genereaza si nu se mai incarca cereri
    if (inchisa) {
        return (
            <Box bg="white" mt="15px" align="center">
                <MesajInchidere>
                    <Text size="sm" mt="xs" fw={600}>
                        {cerere
                            ? 'Cererea ta o poți descărca din pasul „Descarcă cererea”.'
                            : 'Nu ai încărcat nicio cerere înainte de închiderea platformei.'}
                    </Text>
                </MesajInchidere>
                <Title order={3}>Bine ai venit, {student && student.nume + ' ' + student.prenume}.</Title>
                <Text>Profesorul tău coordonator este {professor && professor.nume + ' ' + professor.prenume}.</Text>
            </Box>
        );
    }

    return (
        <Box bg="white" mt="15px" align="center">
            <Grid>
                {/*  <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
                    <Title>Din păcate, nu mai poți genera o nouă cerere. Sesiunea acestui an s-a închis.</Title>
                </Grid.Col>*/}
                {modificariSolicitate && (
                    <Grid.Col span={12}>
                        <Alert color="orange" title="Profesorul coordonator a solicitat modificări:" style={{ textAlign: 'left' }}>
                            <Text size="sm" style={{ whiteSpace: 'pre-wrap', fontStyle: 'italic' }}>"{modificariSolicitate}"</Text>
                            <Text size="sm" mt="xs">
                                Corectează cererea, semneaz-o și încarc-o din nou.
                                {cerere.e_semnat === 1 && ' Cererea semnată anterior rămâne valabilă până când profesorul o semnează pe cea nouă.'}
                            </Text>
                        </Alert>
                    </Grid.Col>
                )}
               <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                    <Title order={3}>  Bine ai venit, {student && student.nume + ' ' + student.prenume}.</Title>
                    <Text>Profesorul tău coordonator este {professor && professor.nume + ' ' + professor.prenume}.</Text>
                    <Text>Titlul orientativ din solicitare: <i>'{solicitare && solicitare.titlu}'</i></Text>
                    <TextInput
                        value={titluCerere}
                        onChange={(event) => setTitluCerere(event.currentTarget.value)} withAsterisk
                        label="Introdu titlul FINAL al licenței, stabilit cu profesorul, generează cererea precompletată și semnează fișierul."
                        placeholder="Titlul licenței"
                        size="md" mt="15px"
                        style={stilLatime}
                    />
                    {titluIncarcare ? <Text>Ai salvat deja titlul „{titluIncarcare}”.</Text> : <Text>Nu ai salvat niciun titlu.</Text>}
                    <Button style={() => ({ ...stilLatime(), marginBottom: '25px', marginTop: '10px' })}
                    disabled={titluCerere.trim().length < 1}
                    // disabled
                     onClick={adaugaCerere} variant='contained'>Salvează titlul</Button>
                    {student && <MyDocument
                        className='doc'
                        student={student}
                        professor={professor}
                        titlu={titluIncarcare}
                    ></MyDocument>}
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                    {/* incarcarea apare doar daca nu exista nicio cerere sau daca profesorul a cerut modificari */}
                    {!poateIncarca && (
                        <Text mt="15px" c="dimmed">
                            {cerere.e_semnat === 1
                                ? 'Cererea ta a fost semnată. O cerere nouă poate fi încărcată doar dacă profesorul coordonator solicită modificări.'
                                : 'Cererea ta a fost trimisă și așteaptă semnătura profesorului coordonator. Nu poți încărca o altă cerere până când profesorul o semnează sau solicită modificări.'}
                        </Text>
                    )}
                    {poateIncarca && (
                        <>
                            <Input.Wrapper style={stilLatime} mt="15px">
                                <FileInput onChange={onFileChange}
                                    value={file}
                                    accept="application/pdf"
                                    label={modificariSolicitate ? 'Încarcă aici cererea corectată și semnată.' : 'Încarcă aici cererea semnată.'}
                                    placeholder="Click pentru încărcare cerere semnată" withAsterisk
                                    // disabled
                                />
                            </Input.Wrapper>
                            <Box style={stilLatime}>
                                {file && (
                                    <VerificareDocument
                                        fisier={file}
                                        student={student}
                                        profesor={professor}
                                        titlu={titluIncarcare}
                                        rol="student"
                                        intrebare={INTREBARE_STUDENT}
                                        onConfirmare={setConfirmat}
                                    />
                                )}
                            </Box>
                            <Button style={() => ({ ...stilLatime(), marginBottom: '25px', marginTop: '10px' })} onClick={onUpload}
                                loading={seIncarca}
                                // cand nu se mai permite incarcarea cererilor, se inlocuieste cu disabled={true}
                                disabled={titluIncarcare.length === 0 || !file || !confirmat}
                                >
                                {modificariSolicitate ? 'Trimite cererea corectată' : 'Încarcă cererea'}
                            </Button>
                        </>
                    )}
                    {!file && <lottie-player
                        src='https://assets1.lottiefiles.com/packages/lf20_jxgqawba.json'
                        background='transparent'
                        speed='1'
                        style={{ width: '200px', height: '200px' }}
                        loop
                        autoplay
                    ></lottie-player>}
                </Grid.Col>
            </Grid>
        </Box>
    );
}

export default GeneratePage;
